import type { Rule } from '../../core/assetType.js';
import type { ValidationIssue } from '../../core/issues.js';
import type { Gameshow } from '../../schemas/gameshow.js';

import { toPointer } from '../../core/issues.js';

export const startNode: Rule<Gameshow> = {
  code: 'gameshow.start-node',
  check(input): ValidationIssue[] {
    const issues: ValidationIssue[] = [];
    const startId = input.startNodeId;
    const start = input.nodes.find(n => n.id === startId);

    if (!start) {
      return issues;
    }

    const activityType = start.activity?.type;
    if (activityType !== 'start_activity') {
      const idx = input.nodes.findIndex(n => n.id === startId);
      const path: (string | number)[] = ['nodes', idx, 'activity', 'type'];
      issues.push({
        code: 'gameshow.start-node.wrong-activity',
        severity: 'error',
        message: `Start node '${startId}' must use activity type 'start_activity', found '${activityType ?? '(missing)'}'.`,
        path,
        pointer: toPointer(path),
        locator: { nodeId: startId },
        currentValue: activityType,
        constraint: { kind: 'enum', allowedValues: ['start_activity'] },
      });
    }

    return issues;
  },
};
